import React, { useState } from 'react';
import {ImportShareApplications} from "../store/slices/reports";
import { Dialog, DialogTitle, DialogContent, DialogActions, LinearProgress } from "@mui/material";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useDispatch, useSelector } from 'react-redux';
import sampleData from "../img/sample_share_application.csv"; // Adjust the path as necessary

const UploadApplicationsPopup = ({ open, onClose, onUpload }) => {
    const [file, setFile] = useState(null);
    const [progress, setProgress] = useState(0);
      const dispatch = useDispatch();

      const user = JSON.parse(localStorage.getItem('user'));
      const profile_id = user?.data?.profile_id;


    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            setProgress(40); // Simulating progress
        }
    };

    const handleUpload = async () => {
        if (!file) {
            alert("Please select a file to upload.");
            return;
        }
    
        try {
            setProgress(70);
            const data = await dispatch(ImportShareApplications({profile_id:profile_id,csv_file:file})).unwrap();
            console.log("Upload Response:", data);
            setProgress(100);
            onUpload(); // Callback after successful upload
            onClose(); // Close the popup
            handleClose();
        } catch (error) {
            console.log('Error uploading file:', error.message);
            alert("Error uploading file. Please try again.");
        }
    };
    

     // Reset function to clear state
     const handleClose = () => {
        setFile(null);
        setProgress(0);
        onClose();
    };

    const handleDownload = () => {
        // Path to the CSV file in the public folder
        const fileUrl = sampleData; 
    
        // Create a temporary <a> element to trigger the download
        const a = document.createElement("a");
        a.href = fileUrl;
        a.download = "sample_share_application.csv"; // Specify the downloaded file name
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      };

    return (
        <Dialog open={open} onClose={handleClose} className="upload-dialog" maxWidth="sm" fullWidth>
            <div className='d-flex justify-content-between align-items-center '>
            <DialogTitle>Upload file </DialogTitle><a className='footer_url p-3' onClick={handleDownload} style={{cursor:"pointer"}}> Download 
            Sample CSV file</a>
            </div>
            <DialogContent className='text-center'>
                <div className="upload-box">
                    <label htmlFor="file-upload" className="upload-label">
                        <CloudUploadIcon fontSize="large" />
                        <p>Choose file</p>
                        <input id="file-upload" type="file" accept=".csv" onChange={handleFileChange} hidden />
                    </label>
                </div>
                {file && (
                    <div className="file-preview">
                        <p>{file.name} ({(file.size / 1024 / 1024).toFixed(2)} MB)</p>
                        <LinearProgress variant="determinate" value={progress} />
                    </div>
                )}
            </DialogContent>
            <DialogActions>
                <button className='btn ripple btn-cancel' onClick={handleClose}>Cancel</button>
                <button className='btn ripple btn-default' onClick={handleUpload} disabled={!file}>Upload</button>
            </DialogActions>
        </Dialog>
    );
};

export default UploadApplicationsPopup;
